import { render, staticRenderFns } from "./ModalUploadFaceRecognition.vue?vue&type=template&id=b3626330&"
import script from "./ModalUploadFaceRecognition.vue?vue&type=script&lang=js&"
export * from "./ModalUploadFaceRecognition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports